import { render, staticRenderFns } from "./premium-form-endorsement.vue?vue&type=template&id=e49718e6&scoped=true&"
import script from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
export * from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./premium-form-endorsement.vue?vue&type=style&index=0&id=e49718e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49718e6",
  null
  
)

export default component.exports